import { SearchOutlined, PlusOutlined } from "@ant-design/icons";
import { Input, List } from "antd";
import { useState } from "react";
import { searchSerie } from "../../api/Search";
import SerieCard from "./SerieCard";

const SearchSerie = (props) => {
  const { type, onClickAdd, renderType } = props;

  const [searchInput, setSearchInput] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [isLoading, setIsloading] = useState(false);

  let timeout = null;

  const loadData = async (input) => {
    if (input.length > 0) {
      setIsloading(true);
      // faire la recherche
      const res = await searchSerie(input);
      console.log(res);
      if (res) setSearchResult(res.series);
      setIsloading(false);
    }
  };

  const handleChange = async (e) => {
    // Clear the timeout if it has already been set.
    // This will prevent the previous task from executing
    // if it has been less than <MILLISECONDS>
    clearTimeout(timeout);

    setSearchInput(e.target.value);

    timeout = setTimeout(function () {
      loadData(e.target.value);
    }, 1000);
  };

  const renderCard = (serie) => {
    return (
      <SerieCard
        serie={serie}
        type={type || "default"}
        onClickAdd={onClickAdd}
      />
    );
  };

  const renderList = (serie) => {
    return (
      <List.Item
        key={serie.id}
        actions={[
          <PlusOutlined
            onClick={() => {
              if (onClickAdd) onClickAdd(serie);
            }}
            key="add"
          />,
        ]}
      >
        {serie.name}
      </List.Item>
    );
  };

  return (
    <>
      <Input
        allowClear
        addonBefore={<SearchOutlined />}
        onChange={handleChange}
        placeholder="Rechercher une série"
        value={searchInput}
      />
      <div
        id="scrollableDiv"
        style={{
          ...(renderType === "list" && { height: 200 }),
          overflow: "auto",
          padding: "0 16px",
        }}
      >
        <List
          style={{ marginTop: 20 }}
          size="small"
          loading={isLoading}
          {...(renderType === "card" && { grid: { column: 3 } })}
          // grid={{ column: 3 }}
          dataSource={searchResult}
          renderItem={renderType === "card" ? renderCard : renderList}
        />
      </div>
    </>
  );
};

export default SearchSerie;
